export const IS_DEBUG = !process.env.NODE_ENV || process.env.NODE_ENV === 'development'

export const CHANNEL_TALK_CHANNEL_ID = '98195'
